module.exports = __webpack_public_path__ + "static/media/7.7b374e02.jpg";